export default {
  end_datetime: "Acquisition Date Stop",
  start_datetime: "Acquisition Date Start",
  acqDateStart: "Acquisition Date Start",
  acqMode: "Acq.Mode",
  cloud_cover: "Cloud Cover",
  datatakesensingstart: "Data take sensing start",
  filename: "File name",
  format: "Format",
  gmlfootprint: "Gml footprint",
  hv_order_tileid: "HV order tileid",
  id: "ID",
  ingestion_date: "Ingestion date",
  level1cpdiidentifier: "Level-1 CPDI iidentifier",
  link: "Link",
  mission: "Mission",
  mission_type: "Mission type",
  orbit_direction: "Pass direction",
  orbitnumber: "Orbit number",
  platform: "Platform",
  platformserialidentifier: "Platform serial identifier",
  processing_baseline: "Processing baseline",
  processing_level: "Processing level",
  product_identifier: "Product identifier",
  product_type: "Product type",
  relativeorbitnumber: "Relative orbit number",
  s2datatakeid: "s2 data takeid",
  sensor: "Sensor",
  sensoroperationalmode: "Sensor operational mode",
  size: "Size",
  summary: "Summary",
  tile_id: "TileId",
  title: "Title",
  uuid: "uuid",
  acquisition_mode: "Acquisition mode",
  acquisitiontype: "Acquisition type",
  beam: "Beam",
  lastorbitnumber: "Last orbit number",
  lastrelativeorbitnumber: "Last relative orbit number",
  missiondatatakeid: "Mission data take ID",
  polarization: "Polarization",
  productclass: "Product class",
  relative_orbit_number: "Relative orbit number",
  slicenumber: "Slice number",
  status: "Status",
  timeliness: "Timeliness",
  creationdate: "Creation date",
  geometry: "Geometry",
  mode: "Mode",
  onlinequalitycheck: "Online quality check",
  passdirection: "Pass direction",
  passnumber: "Pass number",
  pduduration: "PDU duration",
  processingname: "Processing name",
  procfacilityname: "Proc facility name",
  procfacilityorg: "Proc facility org",
  productlevel: "Product level",
  relorbitdir: "Reltive orbit direction",
  relpassdirection: "Relative pass direction",
  relpassnumber: "Relative pass number",
  acquisitionDate: "Acquisition date",
  acquisitionStation: "Acquisition station",
  ascendingNodeLongitude: "Ascending Node Longitude",
  centerOf: "Center of",
  incidenceAngle: "Incidence angle",
  lookSide: "Look side",
  lookside: "Look side",
  maximum_incidence_angle: "Maximum incidence angle",
  minimum_incidence_angle: "Minimum incidence angle",
  orbit_number: "Orbit number",
  parentIdentifier: "Parent identifier",
  sensorResolution: "Sensor resolution",
  sensorType: "Sensor type",
  wrsLatitudeGrid: "WRS Latitude grid",
  wrsLongitudeGrid: "WRS Longitude grid",
  browseUrl: "Browse Url",
  bulkOrdered: "Bulk ordered",
  dataAccessUrl: "Data access Url",
  downloadUrl: "Download Url",
  entity_id: "Entity ID",
  fgdcMetadataUrl: "FGDC metadata Url",
  metadataUrl: "Metadata Url",
  modifiedDate: "Modified date",
  orderUrl: "Order Url",
  sceneBounds: "Scene corners",
  endTime: "End Time",
  ordered: "Ordered",
  startTime: "Start Time",
  accuracy: "Accuracy",
  coordinateSystem: "Coordinate system",
  coverage: "Coverage",
  geoTransform: "geoTransform",
  productItem: "Product item",
  scale: "Scale",
  version: "Version",
  data_type: "Data Type",
  product: "Product",
  spacingLat: "Spacing Latitude",
  spacingLon: "Spacing Longitude",
  collection: "Collection",
  dataset: "Dataset",
  AOI_AREA: "AoI",
  acrossTrackIncidenceAngle: "Across Track Incidence Angle",
  alongTrackIncidenceAngle: "Along Track Incident Angle",
  ascendingNodeDate: "Ascending Node Date",
  completionTimeFromAscendingNode: "Completion Time From Ascending Node",
  illuminationZenithAngle: "Illumination Zenith Angle",
  instrumentAzimuthAngle: "Instrument Azimuth Angle",
  instrumentZenithAngle: "Instrument Zenith Angle",
  startTimeFromAscendingNode: "Start Time From Ascending Node",
  satelliteImageryLeftSearchBar: "Satellite Imagery",
  invalidateLeftSearchBar: "Invalidate",
  massiveReprocessingLeftSearchBar: "Massive Reprocessing",
  closeLeftSearchBar: "close",
  filtersLeftSearchBar: "Filters",
  advancedFiltersLeftSearchBar: "Advanced Filters",
  locationLeftSearchBar: "Location",
  areaOfInterestLeftSearchBar: "Area of Interest",
  wrongPathLeftSearchBar: "wrong path",
  routineOnDemLeftSearchBar: "Routine/On-Dem.",
  routineLeftSearchBar: "Routine",
  onDemandLeftSearchBar: "On-Demand",
  searchModeLeftSearchBarRoutine: "Standard / TileID",
  searchModeLeftSearchBarOnDemand: "Standard / Product Identifier",
  searchModeSingleSearchBar: "Standard",
  searchModeByProductIDSearchBar: "By product ID",
  dateLeftSearchBar: "Date",
  pleaseSelectSearchFilters: "Please Select",
  typeSearchFilters: "type",
  missionSearchFilters: "Mission",
  selectSearchFilters: "Select...",
  selectAllSearchFilters: "Select all",
  interferometricStackSearchFilters: "Interferometric Stack",
  onSearchFilters: "on",
  offSearchFilters: "off",
  searchSearch: "Search",
  clickToPerformSearch: "Click to perform a search",
  deselectToPerformSearch: "Deselect items to perform a new search",
  fillAllSearch: "Fill all the required fields",
  refineSearch: "Refine search with new filters",
  updateSearch: "Update results",
  searchCriteriaResults: "Search Criteria",
  resultsResults: "Results",
  processingParametersResults: "Processing Parameters",
  resultSidebar: "Result Details",
  addToCartResults: "Add to cart",
  processProducts: "Process",
  downloadProducts: "Download",
  clearSelectionsResults: "Clear Selection",
  removeAllSelectionsResults: "Remove all selections",
  downloadResults: "Download Results",
  downloadResultsButtonTooltip: "Download the results in the selected format",
  downloadComponents: "Download Components",
  outputFormats: "Output Formats",
  downloadAllResults: "Download Results",
  downloadResultsButton: "Download",
  aoi: "Area Of Interest",
  downloadResultsCheckbox: "Results",
  downloadResultsRadio: "All Results",
  downloadSelectedResultsResultsRadio: "Selected Results",
  summaryCheckoutModal: "Summary",
  descriptionCartModal: "Description",
  cartNameCartModal: "Cart Name",
  proceedCartModal: "Proceed",
  selectAllHeaderSearch: "Select all",
  selectAllAvailableHeaderSearch: "Select all products available in this page",
  deselectAllAvailableHeaderSearch:
    "deselect all products available in this page",
  matrixHeaderSearch: "Matrix view",
  framingOnSelect: "Framing on Select",
  stackHeaderSearch: "The system groups search results according to the following criteria: \"sensor_mode, orbit_direction, polarization, beam, lookside, track\".",
  imagesHeaderSearch: "Images mode",
  listHeaderSearch: "List view",
  importTheAoiPathImporter: "Import the AOI of KML(.kml) or SHAPEFILE(.zip)",
  errorNotAoiKMLPathImporter: "Error there is not AOI in KML file",
  errorParseKmlPathImporter: "Error to parse KML file",
  errorNotAoiShapePathImporter: "Error there is not AOI in Shape file",
  errorParseShapePathImporter: "Error to parse Shape file",
  aoiNotSupportedPathImporter: "AOI file format not supported",
  geoJSONImportedPathImporter:
      "Successfully GeoJSON content imported, the first of ${result.polygons.length} has been imported",
  kmlImportedPathImporter:
    "Successfully KML file imported, the first of ${result.polygons.length} has been imported",
  shapeImportedPathImporter:
    "Successfully Shape file imported, the first of ${geoJson.features.length} has been imported",
  selectThisProduct: "Select this product",
  deselectThisProduct: "deselect this product",
  alreadyInCartProduct: "This product is already in the cart",
  couldAlreadyInCartProduct: "This product could already be in the cart",
  detailsProduct: "details",
  previewProduct: "preview",
  previewNotAvailableProduct: "Preview not available",
  centeringProduct: "centering",
  processingServicesSidebar: "Processing service",
  informationProductsSidebar: "Information Products",
  acqDateStartSearchResults: "Acq. Date start",
  dateInvalidDateField:
    "The date interval is invalid, please select another '${secondaryLabelText}' date",
  noDataDispatchAction: "No data available for this request",
  unauthorizedMissionsDispatchAction: "Missing authorization for selected mission/s",
  unableAddItemsDispatchActions:
    "Sorry, unable to add all items. Please, check your cart and if the error persists contact our Customer Support Team",
  unableSubmitAllJobs:
      "Sorry, unable to submit all the jobs. Please, check your jobs and if the error persists contact our Customer Support Team",
  unableDownloadAllProducts:
      "Sorry, unable to download all the products. Please, check your products and if the error persists contact our Customer Support Team",
  itemsAddToCart:
    "Items successfully added to Cart. Please go to the cart to finalize your order",
  productsDownloaded:
      "Products successfully downloaded",
  jobsSubmitted:
      "Jobs successfully submitted. Please go to the My Account page to check the progress of your jobs",
  addingCartCartHelper:
    "You are adding ${statisticsList} to your Cart. Please go to the Cart to finalize your order",
  addingCartAOICartHelper:
    "You are adding ${statisticsList} to your Cart but some items are outside the AoI. If you proceed, outside items will be removed. Please go to the Cart to finalize your order",
  noItemsCartHelper: "No selected items intersect the AoI",
  submitJobSummary: "You are adding ${scenes} scene of ${mission} to your processing.",
  downloadProductsSummary: "You are going to download ${scenes} scene of ${mission}.",
  dowloadLimitWarn: "Your remaining daily download limit is ${limit} scenes.",
  jobLimitWarn: "Your remaining daily processing limit is ${limit} scenes.",
  jobInsertProductionParameters: "Please, select the production parameters.",
  and: " and ",
  addingOneItemSearchSidebar:
    "You are adding 1 item to your Cart. Please go to the Cart to finalize your order",
  polygonModifiedShapeHelper:
    "The polygon was modified as only convex polygons are accepted",
  polygonInscribedModifiedShapeHelper:
    "The search will be performed as the circumscribed circle of the polygon",
  digitalGlobeRequiresValidateShape:
    "Please note that DigitalGlobe requires that order areas have a minimum width of 3 Km in any direction (5 km for GeoEye-1).",
  ondemandDTOsOption: "Please select the preferred option:",
  allDTOs: "One separate order for each DTO",
  singleDTO: "Order with all selected DTOs (only one will be acquired)",
  manySelected: "%s selected",
  allSelected: "All selected",
  tenResultsPerPage: "10 Results per page",
  twentyfiveResultsPerPage: "25 Results per page",
  fiftyResultsPerPage: "50 Results per page",
  hundredResultsPerPage: "100 Results per page",
  page: "Page",
  of: "of",
  tooltipCoordinates:
    "The coordinate points must respect the [Lon - Lat] format",
  tooltipFilters:
    "Filters are displayed dynamically, depending on the selected parameters.",
  dateUTCLeftSearchBar: "All dates are in UTC timezone",
  defineProcessingParameters: "DEFINE PROCESSING PARAMETERS",
  tooltipDefineProcessingParameters:
    "Define processing parameters for the selected images",
  globalMapView: "Global Map View",
  darkMap: "Dark map",
  streetsMap: "Streets map",
  topographicMap: "Topographic map",
  satelliteMap: "Satellite map",
  satelliteMapWithLabels: "Satellite map with labels",
  areaConstraintsMaxErrorMessage:
    "The defined area of interest does not match mission constraints for the order (Maximum Area size: ${maxArea} km²)",
  areaConstraintsMinErrorMessage:
    "The defined area of interest does not match mission constraints for the order (Minimum Area size: ${minArea} km²)",
  incorrectCoordinatesMessage:
    "The defined area of interest has incorrect coordinates",
  areaTooBigMessage:
    "Area of interest is too big, please reduce it or contact our Customer Service Team to receive dedicated support.",
  radiusGreaterThan0message: "The radius of circle must be greater than 0Km",
  circularAOInotAllowedForMission:
    "Circular area of interest is not allowed for the selected Mission.",
  radiusExceedsTheMaxRadiusForSelectionMessage:
    "Radius exceeds the maximum value of ${maxRadius} km for the selected ${triggerNameLabel}. Please reduce the radius or change the ${triggerNameLabel}.",
  radiusExceedsTheMaxRadiusMessage:
    "Radius exceeds the maximum value of ${maxRadius} km. Please reduce the radius.",
  radiusExceedsTheMinRadiusForSelectionMessage:
    "Radius exceeds the minimum value of ${minRadius} km for the selected ${triggerNameLabel}. Please increment the radius or change the ${triggerNameLabel}.",
  radiusExceedsTheMinRadiusMessage:
    "Radius exceeds the minimum value of ${minRadius} km. Please increment the radius.",
  exportAOIinKMLfile: "Export the area of interest in a KML(.kml) file",
  aoiMustBeFullyCovered:
    "The AoI must be fully covered with the minimum number of acquisitions. Please modify your order or contact the Customer Support",
  yuoAreAdding2ScenesOfCosmo:
    "You are adding 2 scenes of COSMO-SkyMed (I Generation) to your Cart. Please go to the Cart to finalize your order",
  unableToAddItemsTooCartMessage:
    "Sorry, unable to add items to your Cart. Please try again. If the error persists, please contact our Customer Support Team",
  unableSubmitJobs:
      "Sorry, unable to submit the jobs. Please try again. If the error persists, please contact our Customer Support Team",
  unableDownloadProducts:
      "Sorry, unable to download the products. Please try again. If the error persists, please contact our Customer Support Team",
  errorsGettingCount:
      "Sorry there was an error retrieving your account data, please try again.",
  errorBeforeProceeding:
    "${errorMessage}: before proceeding, please ensure items have not been added to the car",
  errorBeforeProceedingDownload:
      "${errorMessage}: before proceeding, please ensure Products have not been downloaded",
  errorBeforeProceedingJobs:
      "${errorMessage}: before proceeding, please ensure Jobs have not been submitted",
  errorDownloadingFile:
    "Error downloading the file",
  selectAtLeastOneItem: "Select at least one item before proceeding to cart",
  potentialDTOMessageLine0:
    "Warning, cart can contain 96 items at most.",
  potentialDTOMessageLine1:
    "There are ${totalItemsCount} potential Data Collection Opportunities (DTO) available in the selected period.",
  potentialDTOMessageLine2:
    "The final selection of the DTO to be used for the sensing will be performed by the data provider.",
  onDemNotAvaillable: "On-Demand is Not Available",
  searchModeNotAvaillable: "Search Mode Functionality is Not Available",
  selectThisStack: "Select this stack",
  deselectThisStack: "Deselect this stack",
  stackIdentifier: "Stack identifier",
  passDirection: "PASS direction",
  latitude: "Latitude",
  longitude: "Longitude",
  radius: "Radius",
  units: "Units",
  done: "Done",
  circleCenterToolDisclaimer:
    "*All satellite modes will be activated on the base of the size of the AOI required.",
  meters: "meters",
  kilometers: "kilometers",
  miles: "miles",
  coordinatesInjection: "Search by Coordinates",
  degrees: "degrees",
  minutes: "minutes",
  seconds: "seconds",
  nord: "north",
  sud: "south",
  east: "east",
  ovest: "west",
  roundingBoxButtonModal: "Bounding Box",
  circleButtonModal: "Circle",
  KMLButtonModal: "KML",
  geoJsonButtonModal: "GeoJson",
  productIdentifiersSelectedMessage: "You are performing a search by Product Identifiers, all other advanced filters will be ignored",
  tileIDsSelectedMessage: "You are performing a search by Tile IDs, all other advanced filters will be ignored",
  isRequired: "is required",
  selectAtLeastToDefineProcessingParameters: "Select at least ${number} items to define processing parameters",
  selectAtMaximumToDefineProcessingParameters: "Select at maximum ${number} items to define processing parameters",
  selectAtLeastStackToDefineProcessingParameters: "Select at maximum ${number} stacks to define processing parameters",
  selectAtMaximumStackToDefineProcessingParameters: "Select at maximum ${number} stacks to define processing parameters",
  upperLeft: "Upper Left",
  lowerRight: "Lower Right",
  rawDegrees: "Decimal Degrees",
  chooseFile: "Choose File",
  importKmlShapeLabel: "Import KML or ShapeFile (please zip the shape file components)",
  degMinSec: "Degrees, minutes, seconds",
  geoJsonLabel: "Copy and paste your GeoJSON content",
  singleSite: "Single site",
  true: "True",
  false: "False",
  tileIds: "Tile IDs",
  tileIdsPlaceholder: "Insert a list of Tile IDs, e.g. wsdf_00_dsdw_sds8, acdf_10_dsdw_sds9)",
  recordNumbers: "Product Identifiers",
  recordNumberPlaceholder: "Insert a list of Product Identifiers, e.g. ID1, ID2)",
  locationButtonModal: "Location",
  locationLabel: "Insert the location to search",
  locationTooltip: "Search location",
  customerOrderNumber: "Customer order number",
  upperCornerLatPlaceholder: "E.g. 41.97",
  upperCornerLngPlaceholder: "E.g. 12.40",
  lowerCornerLatPlaceholder: "E.g. 41.81",
  lowerCornerLngPlaceholder: "E.g. 12.57",
  radiusPlaceholder: "E.g. 100",
  geoJsonErrorFeatures: "GeoJSON with multiple features not allowed",
  degreesLatPlaceholder: "Eg. 41",
  minutesLatPlaceholder: "Eg. 54",
  secondsLatPlaceholder: "Eg. 10",
  degreesLngPlaceholder: "Eg. 12",
  minutesLngPlaceholder: "Eg. 29",
  secondsLngPlaceholder: "Eg. 46",
  acquisition_status: "Acquisition status",
  datetime: "Datetime",
  ownership: "Ownership",
  ownership_expiration: "Ownership expiration",
  resolution: "Resolution",
  resolution_class: "Resolution class",
  path: "Path",
  row: "Row",
  grid_square: "Grid square",
  latitude_band: "Latitude band",
  utm_zone: "UTM zone",
  delayed: "Delayed",
  routine: "Routine",
  onDemand: "On Demand",
  routineOrOnDemandLeftSearchBar: "Search mode",
  tileId: "Tile ID",
  RecordNumber: "Product Identifier",
  maxBaseline: "Max Baseline [m]",
  enterValue: "Enter a Value",
  baselineFilter: "Baseline Filter",
  invalidate: "Invalidate",
  validate: "Validate",
  invalidate_mode_invalidate: "Invalidate",
  invalidate_mode_validate: "Validate",
  invalidate_modeNotAvailable: "Invalidate not available",
  invalidateModeLeftSearchBar: "Validate/Invalidate",
  invalidateSearchResultsText: "The search has found ${scenes} scenes in the catalogue matching the specifications.",
  invalidateSearchResultsProceedText: "Proceed to invalidate the resulting scenes.",
  validateSearchResultsProceedText: "Proceed to validate the resulting scenes.",
  reprocess: "Reprocess",
  reprocessSearchResultsText: "The search has found ${scenes} scenes in the catalogue matching the specifications.",
  reprocessingInProgress: "There are ${jobs} scenes currently processed.",
  reprocessSearchResultsProceedText: "Proceed to reprocess the resulting scenes.",
  infoLabelSearchModeRoutine: "Routine Mode: the search identifies the automatically generated products already available in the system.",
  infoLabelSearchModeOnDemand: "On-Demand Mode: the search identifies the L0File from which to generate the desired products.",
  infoLabelInterferometrickStack: "The system groups the search results according to the following criteria: \"sensor_mode, orbit_direction, polarization, beam, lookside and track.\"",
  infoLabelSearchTypeInterferometrickDisabled: "Searching by Tile ID is inhibited with interferometric stack enabled since the Tile ID alone guarantees the interferometric stack.",
  infoLabelSearchTypeInterferometrickDisabledOnDemand: "Searching by Product Identifier is inhibited with interferometric stack enabled since the Product Identifier alone guarantees the interferometric stack.",
  infoLabelSearchType: "The Tile ID represents a unique identifier of a particular frame of a MapItaly swipe.",
  infoLabelSearchTypeOnDemand: "The Product Identifier represents a unique identifier of a particular frame of a MapItaly swipe.",
  cannotDrawWithSearchByTileID: "It is not possible to draw an AOI when searching by Tile ID",
  cannotDrawWithSearchByProductIdentifier: "It is not possible to draw an AOI when searching by Product Identifier",
}
